import React, { useState } from "react";
import ReactCountryFlag from "react-country-flag";
import { countries } from "countries-list";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../assets/logo.svg";
import ReCAPTCHA from "react-google-recaptcha";

const DigitalProduct = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobileNo: "",
    email: "",
    country: "IN",
    scratchCardNo: "",
    subscriptionType: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  // Convert countries-list data to array format
  const countryList = Object.entries(countries)
    .map(([code, data]) => ({
      code,
      name: data.name,
      flag: code,
      dialCode: data.phone,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.firstName.trim())
      newErrors.firstName = "First Name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last Name is required";
    if (!formData.mobileNo.trim())
      newErrors.mobileNo = "Mobile No. is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.country) newErrors.country = "Country is required";
    if (!formData.scratchCardNo.trim())
      newErrors.scratchCardNo = "Scratch Card No. is required";
    if (!captchaVerified) newErrors.captcha = "Please verify the CAPTCHA";
    // if (!formData.subscriptionType) newErrors.subscriptionType = 'Subscription Type is required';
    return newErrors;
  };

  const handleCaptchaChange = (value) => {
    console.log(value)
    setCaptchaVerified(!!value);
    if (value) {
      setErrors((prev) => ({ ...prev, captcha: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const selectedCountry = countryList.find(
      (country) => country.code === formData.country
    );

    const mobileWithDialCode = selectedCountry
      ? `${selectedCountry.dialCode}${formData.mobileNo}`
      : formData.mobileNo;

    setLoading(true);
    const payload = {
      scratchCode: formData.scratchCardNo,
      emailId: formData.email,
      mobileNo: mobileWithDialCode,
      firstName: formData.firstName,
      lastName: formData.lastName,
    };

    try {
      const result = await fetch(
        `${process.env.REACT_APP_API_MISC_API}/digital-download/activateScratchCode`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const response = await result.json();

      if (response?.data?.success) {
        toast.success('Your activation link to download digital content has been sent to your WhatsApp and Email.');
        setTimeout(() => {
          window.location.reload();
        }, [2000]);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      if (error?.message) {
        toast.error(error?.message);
      } else {
        toast.error("An unknown error occurred while activating the scratch code.");
      }
    } finally {
      setLoading(false);
    }
  };

  console.log("formdata", formData);

  return (
    <>
      <div className="min-h-screen bg-gray-50 flex flex-col items-center">
        <nav className="w-full bg-white shadow-md p-4">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <button className="text-black text-2xl font-bold">
              <img src={logo} alt="Logo" className="h-20 w-72" />
            </button>
          </div>
        </nav>

        <div className="bg-[#f8f8f8] w-full max-w-4xl p-8 mt-8">
          <h1 className="text-4xl font-bold text-center text-orange-600 mb-8">
            Digital Download Activation
          </h1>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-base font-medium text-gray-700 mb-2">
                  First Name*
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/[^a-zA-Z\s]/g.test(value)) {
                      e.preventDefault();
                    } else {
                      handleChange(e);
                    }
                  }}
                  className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500"
                />
                {errors.firstName && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.firstName}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-base font-medium text-gray-700 mb-2">
                  Last Name*
                </label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/[^a-zA-Z\s]/g.test(value)) {
                      e.preventDefault();
                    } else {
                      handleChange(e);
                    }
                  }}
                  className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500"
                />
                {errors.lastName && (
                  <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>
                )}
              </div>

              <div>
                <label className="block text-base font-medium text-gray-700 mb-2">
                  Mobile No.*
                </label>
                <input
                  type="tel"
                  name="mobileNo"
                  value={formData.mobileNo}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500"
                  placeholder="Enter mobile number"
                />
                {errors.mobileNo && (
                  <p className="text-red-500 text-sm mt-1">{errors.mobileNo}</p>
                )}
              </div>

              <div>
                <label className="block text-base font-medium text-gray-700 mb-2">
                  Email Id.*
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500"
                />
                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                )}
              </div>
              <div className="md:col-span-2">
                <h2 className="text-sm font-semibold text-gray-700">
                  Your activation link to download digital content will be sent
                  on the provided Mobile No and Email Id.
                </h2>
              </div>

              <div>
                <label className="block text-base font-medium text-gray-700 mb-2">
                  Country*
                </label>
                <select
                  name="country"
                  value={formData.country || "IN"}
                  onChange={handleChange}
                  className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500 bg-white "
                >
                  <option value="">-Select Country-</option>
                  {countryList.map((country) => (
                    <option key={country.code} value={country.code}>
                      <ReactCountryFlag
                        countryCode={country.code}
                        svg
                        className="mr-2"
                      />
                      {country.name} ({country.dialCode})
                    </option>
                  ))}
                </select>
                {errors.country && (
                  <p className="text-red-500 text-sm mt-1">{errors.country}</p>
                )}
              </div>
              <div>
                <label className="block text-base font-medium text-gray-700 mb-2">
                  Scratch Card No.*
                </label>
                <input
                  type="text"
                  name="scratchCardNo"
                  value={formData.scratchCardNo}
                  onChange={handleChange}
                  className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500"
                />
                {errors.scratchCardNo && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.scratchCardNo}
                  </p>
                )}
              </div>

            </div>

            {/* Scratch Card Section */}
            <div className="mt-8">

              <div>
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_DIGITAL_ACTIVATION_CAPTCHA_KEY}
                  onChange={handleCaptchaChange}
                />
                {errors.captcha && (
                  <p className="text-red-500 text-sm mt-2">
                    {errors.captcha}
                  </p>
                )}
              </div>
            </div>

            <div className="text-center mt-8">
              <button
                type="submit"
                className={`bg-orange-600 text-white px-8 py-3 transition ${loading
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-orange-700"
                  }`}
                disabled={loading}
              >
                {loading ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.5em"
                    height="1.5em"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#FFFFFF"
                      d="M20.27,4.74a4.93,4.93,0,0,1,1.52,4.61,5.32,5.32,0,0,1-4.1,4.51,5.12,5.12,0,0,1-5.2-1.5,5.53,5.53,0,0,0,6.13-1.48A5.66,5.66,0,0,0,20.27,4.74ZM12.32,11.53a5.49,5.49,0,0,0-1.47-6.2A5.57,5.57,0,0,0,4.71,3.72,5.17,5.17,0,0,1,9.53,2.2,5.52,5.52,0,0,1,13.9,6.45,5.28,5.28,0,0,1,12.32,11.53ZM19.2,20.29a4.92,4.92,0,0,1-4.72,1.49,5.32,5.32,0,0,1-4.34-4.05A5.2,5.2,0,0,1,11.6,12.5a5.6,5.6,0,0,0,1.51,6.13A5.63,5.63,0,0,0,19.2,20.29ZM3.79,19.38A5.18,5.18,0,0,1,2.32,14a5.3,5.3,0,0,1,4.59-4,5,5,0,0,1,4.58,1.61,5.55,5.55,0,0,0-6.32,1.69A5.46,5.46,0,0,0,3.79,19.38ZM12.23,12a5.11,5.11,0,0,0,3.66-5,5.75,5.75,0,0,0-3.18-6,5,5,0,0,1,4.42,2.3,5.21,5.21,0,0,1,.24,5.92A5.4,5.4,0,0,1,12.23,12ZM11.76,12a5.18,5.18,0,0,0-3.68,5.09,5.58,5.58,0,0,0,3.19,5.79c-1,.35-2.9-.46-4-1.68A5.51,5.51,0,0,1,11.76,12ZM23,12.63a5.07,5.07,0,0,1-2.35,4.52,5.23,5.23,0,0,1-5.91.2,5.24,5.24,0,0,1-2.67-4.77,5.51,5.51,0,0,0,5.45,3.33A5.52,5.52,0,0,0,23,12.63ZM1,11.23a5,5,0,0,1,2.49-4.5,5.23,5.23,0,0,1,5.81-.06,5.3,5.3,0,0,1,2.61,4.74A5.56,5.56,0,0,0,6.56,8.06,5.71,5.71,0,0,0,1,11.23Z"
                    >
                      <animateTransform
                        attributeName="transform"
                        dur="1.5s"
                        repeatCount="indefinite"
                        type="rotate"
                        values="0 12 12;360 12 12"
                      />
                    </path>
                  </svg>
                ) : (
                  "Activate Now"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default DigitalProduct;

/*import React, { useState } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { countries } from 'countries-list';

const DigitalProduct = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        mobileNo: '',
        email: '',
        country: '',
        scratchCardNo: '',
        subscriptionType: '',
    });

    const [errors, setErrors] = useState({});

    // Convert countries-list data to array format
    const countryList = Object.entries(countries).map(([code, data]) => ({
        code,
        name: data.name,
        flag: code,
        dialCode: data.phone
    })).sort((a, b) => a.name.localeCompare(b.name));

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        let newErrors = {};
        if (!formData.firstName.trim()) newErrors.firstName = 'First Name is required';
        if (!formData.lastName.trim()) newErrors.lastName = 'Last Name is required';
        if (!formData.mobileNo.trim()) newErrors.mobileNo = 'Mobile No. is required';
        if (!formData.email.trim()) newErrors.email = 'Email is required';
        if (!formData.country) newErrors.country = 'Country is required';
        if (!formData.scratchCardNo.trim()) newErrors.scratchCardNo = 'Scratch Card No. is required';
        if (!formData.subscriptionType) newErrors.subscriptionType = 'Subscription Type is required';
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = validateForm();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            console.log('Form submitted successfully:', formData);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center">
            <nav className="w-full bg-white shadow-md p-4">
                <div className="max-w-6xl mx-auto flex items-center justify-between">
                    <button className="text-black text-2xl font-bold">
                        <img src="/logo.jpeg" alt="Logo" className="h-16 w-16" />
                    </button>
                </div>
            </nav>

            <div className="bg-[#f8f8f8] w-full max-w-4xl p-8 mt-8">
                <h1 className="text-4xl font-bold text-center text-orange-600 mb-8">
                    Subscription Activation
                </h1>

                <form className="space-y-6" onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-base font-medium text-gray-700 mb-2">
                                First Name*
                            </label>
                            <input
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500"
                            />
                            {errors.firstName && (
                                <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-base font-medium text-gray-700 mb-2">
                                Last Name*
                            </label>
                            <input
                                type="text"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500"
                            />
                            {errors.lastName && (
                                <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-base font-medium text-gray-700 mb-2">
                                Mobile No.*
                            </label>
                            <input
                                type="tel"
                                name="mobileNo"
                                value={formData.mobileNo}
                                onChange={handleChange}
                                className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500"
                                placeholder="Enter mobile number"
                            />
                            {errors.mobileNo && (
                                <p className="text-red-500 text-sm mt-1">{errors.mobileNo}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-base font-medium text-gray-700 mb-2">
                                Email Id.*
                            </label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500"
                            />
                            {errors.email && (
                                <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                            )}
                        </div>

                        <div className="md:col-span-2">
                            <label className="block text-base font-medium text-gray-700 mb-2">
                                Country*
                            </label>
                            <select
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                                className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500 bg-white"
                            >
                                <option value="">-Select Country-</option>
                                {countryList.map((country) => (
                                    <option key={country.code} value={country.code}>
                                        <ReactCountryFlag
                                            countryCode={country.code}
                                            svg
                                            className="mr-2"
                                        />
                                        {country.name} ({country.dialCode})
                                    </option>
                                ))}
                            </select>
                            {errors.country && (
                                <p className="text-red-500 text-sm mt-1">{errors.country}</p>
                            )}
                        </div>
                    </div>

                    <div className="mt-8">
                        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
                            Provide Scratch Card No. & Subscription Type
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-base font-medium text-gray-700 mb-2">
                                    Scratch Card No.*
                                </label>
                                <input
                                    type="text"
                                    name="scratchCardNo"
                                    value={formData.scratchCardNo}
                                    onChange={handleChange}
                                    className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500"
                                />
                                {errors.scratchCardNo && (
                                    <p className="text-red-500 text-sm mt-1">{errors.scratchCardNo}</p>
                                )}
                            </div>

                            <div>
                                <label className="block text-base font-medium text-gray-700 mb-2">
                                    Subscription Type*
                                </label>
                                <select
                                    name="subscriptionType"
                                    value={formData.subscriptionType}
                                    onChange={handleChange}
                                    className="w-full border border-orange-300 p-3 focus:outline-none focus:border-orange-500 bg-white"
                                >
                                    <option value="">-Select-</option>
                                    <option value="Basic">Basic</option>
                                    <option value="Premium">Premium</option>
                                    <option value="Enterprise">Enterprise</option>
                                </select>
                                {errors.subscriptionType && (
                                    <p className="text-red-500 text-sm mt-1">{errors.subscriptionType}</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-8">
                        <button
                            type="submit"
                            className="bg-orange-600 text-white px-8 py-3 hover:bg-orange-700 transition"
                        >
                            UPDATE DETAIL / ACTIVATE NOW
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DigitalProduct;*/
